import { actions as user } from './user';
import { actions as nav } from './nav';
import { actions as loading } from './loading';
import { actions as error } from './error';
import { actions as brand } from './brand';
import { actions as auth } from './auth';

export default {
  user,
  nav,
  loading,
  error,
  brand,
  auth,
};
